"use client";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/app/components/shadcn/alert-dialog";
import useAlertDialog from "@/app/lib/features/alertDialog/alertDialog.hook";
import { cn } from "@/app/utils/cn";

const AlertDialogManager = () => {
  const { alertDialog, isLoading, hideAlertDialog, setAlertDialogLoading } =
    useAlertDialog();

  if (!alertDialog) return null;

  const handleAction = async () => {
    setAlertDialogLoading(true);
    try {
      await alertDialog.action.onClick();
      // Sadece başarılı olursa dialog kapansın
      hideAlertDialog();
    } catch (error) {
      console.error("AlertDialog action error:", error);
      // Hata olursa dialog açık kalsın
      setAlertDialogLoading(false);
    }
  };

  const handleCancel = () => {
    if (alertDialog.onCancel) {
      alertDialog.onCancel();
    }
    hideAlertDialog();
  };

  const actionVariant = alertDialog.action.variant || "default";

  return (
    <AlertDialog open={true}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{alertDialog.title}</AlertDialogTitle>
          {alertDialog.description && (
            <AlertDialogDescription>
              {alertDialog.description}
            </AlertDialogDescription>
          )}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={handleCancel} disabled={isLoading}>
            {alertDialog.cancelLabel || "İptal"}
          </AlertDialogCancel>
          <button
            onClick={handleAction}
            disabled={isLoading}
            className={cn(
              "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 py-2",
              actionVariant === "destructive" &&
                "bg-red-600 hover:bg-red-700 focus:ring-red-600 text-white",
            )}
          >
            {isLoading
              ? alertDialog.action.loadingLabel || "İşleniyor..."
              : alertDialog.action.label}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default AlertDialogManager;
